import { ReactElement } from 'react'
import { Button, Text } from '../../Atoms'
import { InputGroup } from '../../Molecules'
import { FeedbackButtonsProps } from './props'
import {
    StyledFeedbackButtons,
    StyledButtons,
    StyledInputGroup,
} from './styles'

const FeedbackButtons = ({
    buttons,
    canProceed,
    value,
    error,
    helperText,
    onChangeValue,
    buttonHeight,
    ...props
}: FeedbackButtonsProps): ReactElement => {
    const { text, send, onClickSend, placeholder } = props

    const ArrayOfButtons = buttons.map((button, i) => (
        <Button
            key={i}
            {...button}
            variant={'option'}
            css={{ h: buttonHeight }}
        >
            {button.text}
        </Button>
    ))
    return (
        <StyledFeedbackButtons>
            <Text>{text}</Text>
            <StyledButtons>{ArrayOfButtons}</StyledButtons>

            <StyledInputGroup>
                <InputGroup
                    error={error}
                    onChange={(event) => onChangeValue?.(event)}
                    placeholder={placeholder}
                    helperText={helperText}
                    value={value}
                />
            </StyledInputGroup>

            {(canProceed == undefined || canProceed) && (
                <Button
                    size="small"
                    variant={'success'}
                    css={{
                        justifySelf: 'end',
                    }}
                    data-testid={'feedbackbtntest'}
                    onClick={() => {
                        onClickSend?.(value)
                    }}
                >
                    {send}
                </Button>
            )}
        </StyledFeedbackButtons>
    )
}

export default FeedbackButtons
export { StyledFeedbackButtons }
